import { Card, CardMedia, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { theme } from "./theme";

interface HomeCardProps {
    title: string;
    text: string;
    image: string;
    translations: any;
    link: string;
}

function HomeCard(props: HomeCardProps) {
    const navigate = useNavigate();

    return (
        <Card
            sx={{
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                borderRadius: '16px',
                boxShadow: 'rgba(0, 0, 0, 0.04) 0px 3px 8px',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                overflow: 'hidden',
                cursor: 'pointer',
                backgroundColor: 'white',
                '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 'rgba(0, 0, 0, 0.08) 0px 8px 20px',
                    '& img': {
                        transform: 'scale(1.03)',
                    },
                },
                opacity: 0,
                animation: 'fadeIn 0.8s forwards cubic-bezier(0.23, 1, 0.32, 1)',
                animationDelay: '0.3s',
                '@keyframes fadeIn': {
                    '0%': {
                        opacity: 0,
                        transform: 'translateY(10px)',
                    },
                    '100%': {
                        opacity: 1,
                        transform: 'translateY(0)',
                    },
                },
            }}
            onClick={() => navigate(props.link)}
        >
            <Box sx={{
                position: 'relative',
                width: '100%',
                height: 200,
                overflow: 'hidden'
            }}>
                <Box
                    sx={{
                        position: 'absolute',
                        zIndex: 500,
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backdropFilter: 'blur(1px) brightness(0.99)',
                        borderRadius: 10,
                        p: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                    }}
                >
                    <Typography
                        variant="h3"
                        component="h2"
                        sx={{
                            fontWeight: 600,
                            marginBottom: '12px',
                            color: 'white',
                            fontSize: '1.45rem',
                            letterSpacing: '-0.01em',
                            transition: 'color 0.3s ease',
                        }}
                    >
                        {props.title}
                    </Typography>
                    <Typography
                        variant="body2"
                        component="p"
                        sx={{
                            color: 'white',
                            lineHeight: 1.6,
                            marginBottom: 0,
                            fontSize: '0.95rem',
                            whiteSpace: 'nowrap',
                            textAlign: 'center',
                        }}
                    >
                        {props.text}
                    </Typography>
                </Box>
                <CardMedia
                    component="img"
                    height="100%"
                    image={props.image}
                    title={props.title}
                    sx={{
                        objectFit: 'cover',
                        width: '100%',
                        transition: 'transform 0.4s cubic-bezier(0.23, 1, 0.32, 1)',
                        filter: 'brightness(0.75)',
                    }}
                >
                </CardMedia>
            </Box>
        </Card>
    );
}

export default HomeCard;
